<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow': visible }"
    :style="visible ? 'display:block;' : ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>Petición para retirar saldo</b></h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="handleCloseModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body mt-4">
          <p>
            Nombre: <b>{{ data.user.username }}</b>
          </p>
          <p>
            Fecha del pedido:
            <b>{{ data.creationDate.replace(/T/, " ").replace(/\..+/, "") }}</b>
          </p>
          <p>
            Monto a retirar: <b>SC${{ data.payment.toFixed(2) }}</b>
          </p>
          <p v-for="(data, key) in data.props" :key="key">
            {{ key }}: <b>{{ data }}</b>
          </p>
        </div>
        <div class="row px-3">
          <div class="col-md-3 col-12 my-1">
            <span
              class="btn btn-block btn-secondary mr-2"
              @click="handleCloseModal"
              >Volver</span
            >
          </div>
          <div v-if="data.state != 1" class="col-md-9 col-12 px-0">
            <div class="row m-0">
              <div class="col-md-6 col-12 my-1">
                <span
                  class="btn btn-block btn-danger"
                  @click="handleClickSend(2)"
                  :class="onLoadCancel ? 'd-none' : ''"
                  >Denegar</span
                >
                <span
                  class="btn btn-block btn-danger align-items-center"
                  :class="onLoadCancel ? 'd-flex' : 'd-none'"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span class="pl-2">Denegando...</span>
                </span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span
                  class="btn btn-block btn-treid"
                  @click="handleClickSend(1)"
                  :class="onLoadTransfer ? 'd-none' : ''"
                  >Transferir</span
                >
                <span
                  class="btn btn-block btn-treid align-items-center"
                  :class="onLoadTransfer ? 'd-flex' : 'd-none'"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span class="pl-2">Transfiriendo...</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api2 from "@/tools/Api2";

export default {
  name: "ModalEditTransaction",
  props: {
    visible: Boolean,
    data: Object,
  },
  data() {
    return {
      onLoadTransfer: false,
      onLoadCancel: false,
      input: {
        payment: 0,
      },
    };
  },
  methods: {
    handleCloseModal() {
      this.$emit("close");
    },
    handleClickSend(state) {
      Api2("transaction").put(this.data._id, { state }).then( () => {
        location.href = ""
      });
    },
  },
};
</script>
<style lang="css" scoped>
</style>